module.exports = __webpack_public_path__ + "img/header4.7ea22d19.png";